module.exports = __webpack_public_path__ + "img/Origine_France_Officiel2_petit.6d864d06.png";